// 导航菜单配置
export const navMenuItems = [
  {
    label: '主頁',
    path: '/',
  },
  {
    label: '關於我們',
    path: '/about#1',
  },
  {
    label: '服務列表',
    path: '/services#2',
  },
  {
    label: '客戶真實反饋',
    path: '/feedback#3',
  },
  {
    label: '服務案例',
    path: '/cases#4',
  },
  {
    label: '聯絡我們',
    path: '/contact#5',
  },
];

// 品牌名称
export const brandName = '楓燧堂';
